
namespace Matrix.Workflow {

    @Serenity.Decorators.registerFormatter([Serenity.ISlickFormatter])
    export class DurationFormatter implements Serenity.ISlickFormatter {
        format(ctx: Slick.FormatterContext) {
            return DurationFormatter.formatValue(ctx.value as number);
        }

        public static formatValue(value: number) {
            if (value == null)
                return "";

            var days = Math.floor(value / 86400000);
            value -= days * 86400000;
            var hours = Math.floor(value / 3600000) % 24;
            value -= hours * 3600000;
            var minutes = Math.floor(value / 60000) % 60;
            value -= minutes * 60000;
            var seconds = Math.floor(value / 1000) % 60;
            value -= seconds * 1000;

            return (days > 0 ? (days + ".") : "") +
                Q.zeroPad(hours, 2) + ":" + Q.zeroPad(minutes, 2) + ":" + Q.zeroPad(seconds, 2) + "." + Q.zeroPad(Math.floor(value), 3);
        }
    }
}